module.exports = __webpack_public_path__ + "img/small_t1_cors_nut.prt.a8d6aed6.jpg";